import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";
import { countText } from "../../utils/kitPresentation";

// Admin · Tabs (047 kit; Tab Item 10651:4922): tabs that are links, with a count pill after
// the label ("1,234", as every count on the dashboard prints). The theme draws the 40 px row,
// the grey line and the blue underline.
const LinkTabs = ({ value, tabs, label }) => (
  <Tabs value={value} aria-label={label} variant="scrollable" scrollButtons={false}>
    {tabs.map((t) => (
      <Tab
        key={t.value}
        value={t.value}
        component={RouterLink}
        to={t.to}
        label={
          <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
            {t.label}
            {t.count !== null && t.count !== undefined && (
              <Box
                component="span"
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  height: 26,
                  px: "10px",
                  borderRadius: "9999px",
                  bgcolor: tokens.neutral.bg,
                  color: tokens.text.primary,
                  fontSize: 12,
                  lineHeight: "16px",
                  fontWeight: 500,
                }}
              >
                {typeof t.count === "number" ? countText(t.count) : t.count}
              </Box>
            )}
          </Box>
        }
      />
    ))}
  </Tabs>
);

export default LinkTabs;
